module.exports = __webpack_public_path__ + "1f6f922291e2ee41feb75269e2d18a89.pdf";